import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayDeferredErrorDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayDeferredErrorDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandOverlayDeferredError) {
    JsonSchemaValidator.assert(
      RoomBrandOverlayDeferredErrorDTO.validation,
      data
    );
  }

  toString() {
    return `${this.data.message} (${this.data.code}, ${this.data.errorId})`;
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  private static validationSchema() {
    return {
      type: "object",
      required: ["code", "message"],
      properties: {
        code: {
          type: "number",
          minimum: 0,
          maximum: Number.MAX_SAFE_INTEGER
        },
        message: {
          type: "string",
          minLength: 0,
          maxLength: 2_048
        },
        errorId: {
          type: "string",
          format: "uuid"
        }
      }
    };
  }
}

interface RoomBrandOverlayDeferredError {
  code: number;
  message: string;
  errorId?: string;
}
